export default __webpack_public_path__ + "static/media/fridge1-after2-1440w.54de6079.avif";